module.exports = __webpack_public_path__ + "img/bg-ad.a705bbca.a705bbca.png";